/**
 * Created by Qingger Corp.
 * User: ll
 * Date: 2020/06/27
 * Time: 20:17
 * Desc: 促销活动-新增/编辑
 */
import { Component, Vue, Watch } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import { IPSService } from '@/services/ipsServices';
import { globalElement } from '@/library/utils/globalElement';
import Upload from '@/views/components/upload/upload.vue';
import { appEnvConfig } from '@/configs/appConfigs';
import { EmpServiceAPIActions } from '@/services/empService';
import baseAPIService from '@/services/base/baseAPIService';
import SwiperCp from '@/views/components/pageConfigComponents/swiperCp/swiperCp.vue';
import { Functions } from '@/library/utils/functions';

@Component({
  components: {
    SwiperCp,
    Upload,
  },
})
export default class PromotionDetailEdit extends Vue {
  $refs: {
    form: ElForm;
  };

  // 关联的活动信息
  public promotionInfo: ItemObject = {};

  /**
   * corpId
   */
  public corpId = baseAPIService.resolveCorpId();

  // 显示类型 1 一行两个 2 不换行 3 大图
  public type = 1;

  // 显示数量
  public showNum = 8;

  // 获取是否是当前编辑的模块
  public isActivited = 1;

  // 选中的模块
  public editItem: promotionEditInfo = {};

  // 头图列表
  public headerImageList: Array<string> = [];

  // 头图列表
  public actImageList: Array<string> = [];

  // token
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  // 即将上传的图片下标
  public headerImageIndex = -1;

  // 图片上传地址
  public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  // 规则
  public rules = {};

  // opId
  public opId: number | string = 0;

  // 装修详情
  public editInfo: Array<promotionEditInfo> = [];

  // 是否是编辑
  public isEdit = false;

  /**
   * 是否展示刘海屏
   */
  public isShowBangs = false;

  /**
   * 是否拖动轮播图
   */
  public isLoading = true;

  /**
   * 发布或预览
   */
  public saveOrPre = '';

  /**
   * 是否展示于预览图片
   */
  public isShowCode = false;

  /**
   * 二维码地址
   */
  public imageView = '';

  /**
   * 封装数据结构
   */
  get computedSwiperImg() {
    return this.headerImageList.map((imageUrl) => {
      return {
        imageUrl,
      };
    });
  }

  public created() {
    this.opId = (this.$route.query.id as string) || 0;
    this.isEdit = !!Number(this.$route.query.flag || 0);
    this.getEditInfo();
  }

  /**
   * 选中模块
   * @param val
   */
  public editModule(index, val) {
    this.isActivited = index;
    this.editItem = val;
  }

  /**
   * 移动事件
   * @param evt
   */
  public sortIndex(evt) {
    this.editItem = evt.moved.element;
    this.isActivited = evt.moved.newIndex + 2;
    this.editInfo = [].concat(this.getHeaderImg, this.getSortList);
  }

  /**
   * 图片上传成功时的处理
   * @param res
   * @param file
   */
  public uploadImgSuccess(res: HttpAPIRetItem<any>, file: any) {
    if (this.editItem.filedType == 'ActImage') {
      this.editItem.desc.images.push(res.content);
      return;
    }
    this.getHeaderImg.desc.images.push(res.content);
  }

  /**
   * 上传失败提示
   * @param err
   */
  public uploadImgError(err) {
    const result = JSON.parse(err.message);
    if (result.message) {
      this.$message.error(result.message);
    }
  }

  /**
   * 图片上传之前的格式验证
   * @param file
   * @returns {boolean}
   */
  public onBeforeUpload(file) {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    const isGIF = file.type === 'image/gif';
    const isLt300K = file.size / 1024 <= 1024;
    if (!isJPG && !isPNG && !isGIF) {
      globalElement.message.error('上传图片只支持 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!isLt300K) {
      globalElement.message.error('上传图片大小不能超过 1M!');
    }
    return (isJPG || isPNG || isGIF) && isLt300K;
  }

  /**
   * 选择显示数量
   */
  public selectShowNum(val) {
    this.editItem.desc.showNum = Number(val);
  }

  /**
   * 获取装修详情
   * @returns {null}
   */
  public getEditInfo() {
    const loading = this.$loading({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
      target: document.querySelector('#info') as any,
    });
    IPSService.promotionEditInfo({
      postParams: {
        opId: +this.opId,
      },
    })
      .then((response) => {
        this.editInfo = response.list;
        this.promotionInfo = Object.assign(response.promotionInfo, {
          endTime: Functions.timeFormatSec(response.promotionInfo.endTime),
          startTime: Functions.timeFormatSec(response.promotionInfo.startTime),
        });
        this.editItem = this.getHeaderImg;
        loading.close();
      })
      .catch(() => {
        loading.close();
      });
  }

  /**
   * 获取需要拖动排序的模块
   */
  get getSortList() {
    const result = this.editInfo.filter((element) => {
      return element.filedType == 'ProductGroup' || element.filedType == 'ActImage' || element.filedType == 'ActDescription';
    });
    return result;
  }

  /**
   * 获取头图列表
   */
  get getHeaderImg() {
    const result = this.editInfo.find((element) => {
      return element.filedType == 'HeadImage';
    });
    if (!result) {
      this.editInfo.push({ filedType: 'HeadImage', desc: { images: [] } });
      return { filedType: 'HeadImage', desc: { images: [] } };
    } else {
      return result;
    }
  }

  /**
   * 添加图片模块
   */
  public addActImg() {
    this.editInfo.push({
      filedType: 'ActImage',
      sort: this.editInfo.length,
      desc: {
        images: [],
      },
    });
  }

  /**
   * 添加描述模块
   */
  public addDescribe() {
    this.editInfo.push({
      filedType: 'ActDescription',
      sort: this.editInfo.length,
      desc: {
        productDescription: '',
      },
    });
  }

  /**
   * 封装轮播图数据结构
   */
  get computedHeaderSwiper() {
    return this.getHeaderImg.desc.images.map((element) => {
      return { imageUrl: element };
    });
  }

  /**
   * 封装活动图片轮播图数据结构
   */
  public computedActImageSwiper(sortItem) {
    return sortItem.desc.images.map((el) => {
      return { imageUrl: el };
    });
  }

  /**
   * 活动图片上传成功
   */
  public uploadActImgSuccess(imgUrl) {
    this.editItem.desc.images.push(imgUrl);
  }

  /**
   * 返回上一步
   */
  public goBack() {
    this.$router.push({
      path: '/promotionEdit',
      query: {
        id: this.opId as string,
        flag: Number(this.isEdit).toString(),
      },
    });
  }

  /**
   * 发布促销活动
   */
  public release() {
    const loading = this.$loading({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
      target: document.querySelector('#info') as any,
    });
    let result = [];
    result = result.concat([this.getHeaderImg], this.getSortList);
    this.saveOrPre = '发布';
    if (!result.every(this.validatePro)) {
      loading.close();
      return;
    }
    result.forEach((element, index) => {
      element.sort = index;
    });
    IPSService.savePromotionEditInfo({
      postParams: {
        opId: +this.opId,
        list: result,
      },
    })
      .then((response) => {
        loading.close();
        this.$message.success('发布成功');
        this.$router.push('/promotionActivity');
      })
      .catch(() => {
        loading.close();
      });
  }

  /**
   * 预览
   */
  public preview() {
    const loading = this.$loading({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
      target: document.querySelector('#info') as any,
    });
    let result = [];
    result = result.concat([this.getHeaderImg], this.getSortList);
    this.saveOrPre = '预览';
    if (!result.every(this.validatePro)) {
      loading.close();
      return;
    }
    result.forEach((element, index) => {
      element.sort = index;
    });
    IPSService.promotionPreview({
      postParams: {
        opId: this.opId,
        list: result,
        proCode: this.promotionInfo.proCode,
      },
    })
      .then((response) => {
        loading.close();
        this.imageView = response.cxUrl;
        this.isShowCode = true;
      })
      .catch(() => {
        loading.close();
      });
  }

  /**
   * 移除活动图片或描述模块
   * @param {number,number} flag index
   */
  public remove(index) {
    this.editInfo.splice(this.isActivited - 1, 1);
    this.isActivited = 0;
    this.editItem.filedType = '';
  }

  /**
   * 校验活动模块设置
   */
  public validatePro(val: promotionEditInfo) {
    let result = false;
    switch (val.filedType) {
      case 'ActImage':
        result = !!(val.desc && val.desc.images && val.desc.images.length);
        if (!result) {
          this.$message.warning(`活动图片未设置内容，请设置后${this.saveOrPre}`);
        }
        return result;
      case 'HeadImage':
        result = !!(val.desc && val.desc.images && val.desc.images.length);
        if (!result) {
          this.$message.warning(`活动头图未设置内容，请设置后${this.saveOrPre}`);
        }
        return result;
      case 'ProductGroup':
        result = !!((val.desc.isUseGroupName && val.desc.groupName && val.desc.groupName.trim()) || !val.desc.isUseGroupName);
        if (!result) {
          this.$message.warning(`商品组名称未设置内容，请设置后${this.saveOrPre}`);
        }
        return result;
      case 'ActDescription':
        result = !!(val.desc && val.desc.productDescription);
        if (!result) {
          this.$message.warning(`描述未设置内容，请设置后${this.saveOrPre}`);
        }
        return result;
      default:
        return result;
    }
  }

  /**
   * 关闭预览
   * @return null
   */
  public closePreviewWindow(): void {
    this.isShowCode = false;
  }
}
